module.exports = __webpack_public_path__ + "img/big-quote.4cb77604.svg";